import React from 'react';

import { useClaim } from '~/components/ClaimContainer';

import GenericClaimBarField from './GenericClaimBarField';

type DaysOpenProps = {
  displayName?: string;
};

const DaysOpen = ({ displayName = 'Days Open' }: DaysOpenProps) => {
  const { claim } = useClaim({ claimRequired: true });

  return <GenericClaimBarField title={displayName} content={claim.days_open} />;
};

export default DaysOpen;
